var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.379.818H9.213a3.336 3.336 0 0 0-3.336 3.336v15.41a2.756 2.756 0 0 1-2.76 2.753h17.845a2.751 2.751 0 0 0 2.752-2.752V4.154A3.336 3.336 0 0 0 20.38.818zm-5.583 15.357h-4.68a.75.75 0 0 1 0-1.501h4.68a.75.75 0 1 1 0 1.5zm4.679-3.857h-9.358a.75.75 0 0 1 0-1.501h9.358a.75.75 0 0 1 0 1.501zm0-3.857h-9.358a.75.75 0 0 1 0-1.5h9.358a.75.75 0 0 1 0 1.5z",
    fill: "#F1D131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 13.652v5.913c0 .69-.56 1.25-1.25 1.25h-.009a2.751 2.751 0 0 1-2.752-2.751v-1.076A3.336 3.336 0 0 1 3.7 13.652h.675z",
    fill: "#F1D131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.17f6f97c0ce80c3489cb04595906ad8d.svg";
export { ForwardRef as ReactComponent };